import { useHttp } from '@/shared/lib'
import { useRoute } from 'vue-router'
import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'

const useLoadMeters = () => {
  const http = useHttp()
  const route = useRoute()

  const url = computed(() => `/cabinets/${route.params.object_id}/meters`)

  const queryKey = computed(() => ['load_cabinet_meters', route.params.object_id])

  return useQuery({
    queryKey,
    queryFn: () => http.get(url.value),
    retry: false,
  })
}

export { useLoadMeters }
